import { useEducationStore } from "../../../_store/educationStore";
import { cn } from "../../../utils/useFunctions";
import ViewTableExpensesPdf from "../../education/components/ViewTableExpensesPdf";
import {
  STYLE_PAGE_HORIZONTAL
} from "../styles/pdf.style";

function PdfPageAppendixEducationOne({ page }) {
  const educationData = useEducationStore((state) => state.educationData);

  return (
    <div className="flex flex-col space-y-2">
      {educationData.map((educationItem, index) => {
        return (
          <div key={index} className="flex flex-col space-y-2">
            {/* INFO */}
            <div className={cn(STYLE_PAGE_HORIZONTAL)}>
              <ViewTableExpensesPdf index={index} localEducationData={educationItem} />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default PdfPageAppendixEducationOne;
